import { render, staticRenderFns } from "./Living.vue?vue&type=template&id=51974b74&scoped=true&"
import script from "./Living.vue?vue&type=script&lang=js&"
export * from "./Living.vue?vue&type=script&lang=js&"
import style0 from "./Living.vue?vue&type=style&index=0&id=51974b74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51974b74",
  null
  
)

export default component.exports